import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class LinkDescriptionService {
	url: string = 'RichTextEditor';

	constructor(private http: HttpClient) {}

	public setShortDescription(id: number, content: string) {
		return this.http.post(this.url + '/SetLinkInfoShortDescription', { id, content });
	}

	public setLongDescription(id: number, content: string) {
		return this.http.post(this.url + '/SetLinkInfoLongDescription', { id, content });
	}

	public setPricingInformation(id: number, content: string) {
		return this.http.post(this.url + '/SetLinkInfoPricingInformation', { id, content });
	}

	public setSupportInformation(id: number, content: string)
	{
		return this.http.post(this.url + '/SetLinkInfoSupportInformation', { id, content });
	}

	public editTitle(id: number, title: string) {
		return this.http.put('/linkInformation/editTitle', { id, content: title });
	}
}
